const FALLBACK_NAME = 'pasted-image'
const FALLBACK_EXTENSION = 'png'

export const buildPastedImageName = (type: string, index: number, total: number): string => {
  const extension = type.split('/')[1] || FALLBACK_EXTENSION
  const suffix = total > 1 ? `-${index + 1}` : ''

  return `${FALLBACK_NAME}-${Date.now()}${suffix}.${extension}`
}
